// Angular 2
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';
import * as _ from 'lodash';
import '../../libs/numeral/numeral';
import '../../libs/moment/moment';

// RxJS
import 'rxjs';
// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import '../../../assets/css/font-awesome.css';
import '../../../assets/css/styles.css';




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/boot/vendor.ts